// extracted by mini-css-extract-plugin
module.exports = {"control--select":"dist-es__Select__control--select","select-wrapper":"dist-es__Select__select-wrapper","select-wrapper__arrow":"dist-es__Select__select-wrapper__arrow"};